import { TemplateApi, TemplateListApiModel } from '../../../api/templates/template-api.model';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { BaseModel } from '../../Basic/models/base.model';

export class Template extends BaseModel<Template, TemplateApi>{

    id: number;
    type: StyleTypesApiEnum;
    styleId: number;

    // mutually exclusive
    template?: string;
    templates?: TemplateListApiModel;

    isDefault: boolean;
    defaultReference: string;

    createdByUserId: number;
    createdDate: number;

    lastModifiedByUserId: number;
    lastModifiedDate: number;


    constructor(templateApi?: TemplateApi) {
        super();
        if (templateApi) {
            this.constructFromApiModel(templateApi);
        } else {
            this.constructDefault();
        }
    }

    toApiModel(): TemplateApi {
        return {
            id:                   this.id,
            type:                 this.type,
            styleIds:             [this.styleId],
            template:             this.template,
            isDefault:            this.isDefault,
            createdByUserId:      this.createdByUserId,
            createdDate:          this.createdDate,
            lastModifiedByUserId: this.lastModifiedByUserId,
            lastModifiedDate:     this.lastModifiedDate
        };
    }

    constructFromApiModel(apiModel: TemplateApi) {
        this.id = apiModel.id;
        this.type = apiModel.type;
        this.styleId = (apiModel.styleIds?.length > 0) ? apiModel.styleIds[0] : null;

        if (apiModel.template) {
            this.template = apiModel.template;
        } else if (apiModel.templates) {
            this.templates = apiModel.templates;
        }

        this.isDefault = apiModel.isDefault;
        this.defaultReference = apiModel.defaultReference;

        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = apiModel.createdDate;

        this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
        this.lastModifiedDate = apiModel.lastModifiedDate;
    }


    clone(): Template {
        const clone = new Template(this.toApiModel());

        return clone;
    }

    equals(other: Template): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (this.styleId !== other.styleId) {
            return false;
        }

        if (this.isDefault !== other.isDefault) {
            return false;
        }

        if (this.template !== other.template) {
            return false;
        }

        if (this.lastModifiedByUserId !== other.lastModifiedByUserId) {
            return false;
        }

        if (this.lastModifiedDate !== other.lastModifiedDate) {
            return false;
        }

        if (this.createdByUserId !== other.createdByUserId) {
            return false;
        }

        if (this.createdDate !== other.createdDate) {
            return false;
        }

        return true;
    }

    /** @deprecated Not implemented */
    constructDefault() {}
}
